import { consoleAPI } from '@/providers/apis/console/console';
import { Vue, Component } from 'vue-property-decorator';
import PartnersEdit from './partner-list/partner-list';

@Component({
    name: 'partners',
    components: {
        'partners-list': PartnersEdit,
    },
})

export default class Partners extends Vue {

    // ---------------------------------------------------------------------
    // Properties


    // --------------------------------------------------------------------
    // Hooks

    // ----------------------------------------------------------------
    // Actions

}
